<template>
  <div class="rehab-layout">
    <div class="rehab-layout__content">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
    <van-tabbar v-model="active" fixed route safe-area-inset-bottom placeholder :z-index="5000" active-color="#07c160" inactive-color="#666" @change="onChange">
      <van-tabbar-item icon="home-o" :to="{ name: 'RehabCoursesHome' }" name="RehabCoursesHome">课程中心</van-tabbar-item>
      <van-tabbar-item icon="orders-o" :to="{ name: 'RehabCoursesMy' }" name="RehabCoursesMy">我的课程</van-tabbar-item>
      <van-tabbar-item icon="contact-o" :to="{ name: 'RehabCoursesPerson' }" name="RehabCoursesPerson">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
  
</template>

<script>
export default {
  name: 'RehabCoursesTabbar',
  data () {
    return {
      active: 'RehabCoursesHome'
    }
  },
  created () {
    this.syncActiveWithRoute()
  },
  watch: {
    '$route.path' () {
      this.syncActiveWithRoute()
    }
  },
  methods: {
    onChange () {},
    syncActiveWithRoute () {
      if (this.$route.name === 'RehabCoursesPerson' || this.$route.path.startsWith('/rehab-courses/person')) {
        this.active = 'RehabCoursesPerson'
      } else if (this.$route.name === 'RehabCoursesMy' || this.$route.path.startsWith('/rehab-courses/my')) {
        this.active = 'RehabCoursesMy'
      } else {
        this.active = 'RehabCoursesHome'
      }
    }
  }
}
</script>

<style scoped>
.rehab-layout { position: fixed; left: 0; right: 0; top: 0; bottom: 0; display: flex; flex-direction: column; background: #f7f8fa; }
.rehab-layout__content { flex: 1; box-sizing: border-box; overflow-y: auto; -webkit-overflow-scrolling: touch; }
</style>


